import React from "react";
import Navbar from "../../Components/Navbar";
import ReviewPageSc from "./index.sc";
import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { Card, Button, Modal } from "react-bootstrap";
import { useAuthContext } from "../../hooks";
import { createMemberPerformanceCommentAsPeopleLead } from "../../api/peopleLeadPerformance/createMemeberCommentAsPeoplead";
import parse from "html-react-parser";
import { getOrgUserOrgGoalsAsPl } from "../../api/peopleLeadPerformance/getOrgUserOrgGoalsAsPl";
import "./review.css";
import { Rate } from "antd";
import ReactQuill from "react-quill";
import { getUserGoalsWithTlCommentForPl } from "../../api/peopleLeadPerformance/getOrgUserGoalsWithTlCommentForPl";
import { FaRegCaretSquareDown } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { getPeopleleadCommentForUser } from "../../api/peopleLeadPerformance/getPeopleLeadCommentForUser";
function Index() {
  const navigate = useNavigate();
  const params = useParams();
  const [getMemberPerformance, setGetMemberPerformance] = useState<any[]>([]);
  const auth = useAuthContext();
  const fetchOrguserProjects = async () => {
    await getUserGoalsWithTlCommentForPl(
      auth?.userInfo?.orgs[0]?.id,
      params?.reviewId
    )
      .then((e) => {
        setGetMemberPerformance(e);
      })
      .catch((e) => console.log(e));
  };
  const [formValues, setFormValues] = useState({ rating: 2.5, pl_comment: "" });
  const [refreshPage, setRefreshpage] = useState(false);
  const handleRatingChange = (value: any) => {
    setFormValues((prevState) => ({
      ...prevState,
      rating: value,
    }));
  };

  const handleEditorChange = (value: any) => {
    setFormValues((prevState) => ({
      ...prevState,
      pl_comment: value,
    }));
  };
  const [orgGoals, setOrgGoals] = useState<any[]>([]);

  const handleSubmit = async (event: { preventDefault: () => void }) => {
    event.preventDefault();
    if (!formValues.pl_comment || !formValues.rating) {
      alert("Please Give A valid Field Comment People Lead");
    }
    try {
      const response = await createMemberPerformanceCommentAsPeopleLead(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString(),
        {
          ...formValues,
          org_user_id: params?.reviewId,
        }
      );
      console.log(response.data);
      fetchPeopleLeadComment();
    } catch (error) {
      console.error(error);
    }
  };
  const [peopleLeadComment, setPeopleLeadComment] = useState<any>([]);
  const fetchPeopleLeadComment = async () => {
    await getPeopleleadCommentForUser(
      auth?.userInfo?.orgs[0]?.id,
      params?.reviewId
    )
      .then((e) => {
        console.log(e);
        setPeopleLeadComment(e);
      })
      .catch((e) => console.log(e));
  };
  console.log("pl", getMemberPerformance);
  useEffect(() => {
    fetchOrguserProjects();
    fetchPeopleLeadComment();
    // fetchOrgUserOrgGoals();
  }, []);

  return (
    <ReviewPageSc>
      {getMemberPerformance &&
        getMemberPerformance?.map((data: any) => {
          return (
            <>
              {data?.F_Name + "" + data?.L_Name}
              {data?.objective?.map((data: any) => {
                return (
                  <>
                    {/* <div>{data?.Name}</div> */}
                    <span>
                      <label>Devlopment Objective:</label>{" "}
                      {data?.objective_role}
                    </span>
                    <div>Evaulation :{data?.Evaluation}</div>
                    <div className="development-objective">
                      {parse(data?.Objective)}
                    </div>
                  </>
                );
              })}

              <label>Project Goals</label>
              {data?.project_goals?.map((data: any, idx: any) => {
                return (
                  <>
                    <div className="second-sub-container" key={idx}>
                      <div className="heading-class">
                        <p>Due Date : {data?.DueDate}</p>
                        <p>Project Name:{data?.ProjectName}</p>
                      </div>
                      <h6>Goals:</h6>

                      <div className="project-goals-content">
                        <div className="project-details-goals">
                          {parse(data?.Goals)}
                        </div>
                      </div>
                      <h6>PL Comments:</h6>
                      <div
                        className="project-comments-content"
                        dangerouslySetInnerHTML={{
                          __html: data?.Team_lead_comment,
                        }}
                      ></div>
                    </div>
                  </>
                );
              })}
              <label>Org Goals</label>
              <div className="second-sub-container">
                {data?.org_goals?.map((data: any) => {
                  return (
                    <>
                      <div className="heading-class">
                        <div>OrgGoal Type : {data?.GoalRole}</div>
                        <div>
                          Due Date:{""} {data?.due_date}
                        </div>
                      </div>
                      <div className="project-goals-content">
                        <div className="project-details-goals">
                          {parse(data?.goal)}
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            </>
          );
        })}

      {peopleLeadComment?.length > 0 ? (
        <div className="user-gaol-title-main">
          {peopleLeadComment?.map((data: any) => {
            return (
              <>
                <div>
                  <Rate disabled allowHalf defaultValue={data?.rating} />
                  <div>{data?.final_review}</div>
                  <div></div>
                </div>

                <div>
                  <label>People Lead Comment</label>
                  <div>{parse(data?.pl_comment)}</div>
                </div>
              </>
            );
          })}
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="comments-admin-container">
            <div className="comments-admin">
              <div className="comment-text">Comments</div>
              <div className="comment-box">
                <ReactQuill
                  value={formValues.pl_comment}
                  onChange={handleEditorChange}
                />
              </div>
            </div>
            <div className="ratings-container">
              <div style={{ display: "flex", width: 700, padding: 30 }}>
                <Rate
                  allowHalf
                  defaultValue={2.5}
                  onChange={handleRatingChange}
                />
                <br />
              </div>
            </div>
          </div>
          <div className="approve-button-container">
            <Button type="submit" className="approve-button">
              Approve Goals
            </Button>
          </div>
        </form>
      )}
    </ReviewPageSc>
  );
}

export default Index;
